import React from 'react';
import { FaExclamationCircle, FaExclamationTriangle, FaTimes } from 'react-icons/fa';

const ConfirmationModal = ({
  isOpen,
  title = 'Alert!',
  message = 'Are you sure you want to deactivate your account?',
  confirmText = (
    <>
      <img src="/assets/images/smalldelete.svg" />
      Yes, Deactivate
    </>
  ),
  cancelText = 'Go Back',
  onConfirm,
  onCancel,
  action,
  subMessage = 'They will lose access to their administrator account for your university.',
  hideCancelBtn = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-modal-backdrop" style={{ zIndex: 10000 }}>
      <div
        className="confirm-modal-container position-relative"
        style={{
          width: '500px',
          maxWidth: '90%',
          backgroundColor: '#fff',
          borderRadius: '12px',
          padding: '24px 24px 16px',
          boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.1)',
          textAlign: 'center',
        }}
      >
        {/* Close Icon */}
        <span
          onClick={onCancel}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            cursor: 'pointer',
            fontSize: '20px',
            color: '#5E6278',
          }}
          aria-label="Close"
        >
          <FaTimes />
        </span>

        {/* Title */}
        <h4
          className="mb-3"
          style={{
            textAlign: 'left',
            fontWeight: 'bold',
            fontSize: '18px',
            marginBottom: '16px',
            fontWeight: '500px',
          }}
        >
          {title}
        </h4>

        {/* Icon */}
        {(action === 'Delete' || action === 'Error' || action === 'Warning') && (
          <div className="mb-3">
            {action === 'Delete' && <img src="/assets/images/delete.svg" />}
            {action === 'Error' && <FaExclamationCircle style={{ fontSize: '48px', color: '#D90F21' }} />}
            {action === 'Warning' && <FaExclamationTriangle style={{ fontSize: '48px', color: '#FDC674' }} />}
          </div>
        )}

        {/* Main Message */}
        <p className="fw-semibold" style={{ fontSize: '16px', color: '#181C32' }}>
          {message}
        </p>

        {/* Sub Message */}
        <p className="text-muted font-12" style={{ color: '#5E6278' }}>
          {subMessage}
        </p>

        {/* Buttons */}
        <div className="d-flex flex-column align-items-center gap-2 mt-4">
          <button
            onClick={onConfirm}
            className="btn w-100"
            style={{
              backgroundColor: action === 'Delete' ? '#D90F21' : '#007bff',
              color: '#fff',
              padding: '10px 16px',
              fontWeight: 'bold',
              borderRadius: '8px',
              border: 'none',
            }}
          >
            {confirmText}
          </button>
          {!hideCancelBtn && (
            <a
              onClick={onCancel}
              style={{
                cursor: 'pointer',
                fontSize: '14px',
                color: '#1976d2',
                textDecoration: 'none',
              }}
            >
              {cancelText}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
